import { useNavigate } from "react-router-dom";
import { Table } from "src/components/organisms/Table";
import {
  jobNumberColumn,
  tickerColumn,
  typeColumn,
  recordDateColumn,
  stageColumn,
} from "src/components/organisms/Table/columns";
import { BankruptcyEventResult } from "src/store/globalSearch/types";

interface Props {
  bankruptcyEvents: BankruptcyEventResult[];
  closeSearchDrawer: () => void;
}

export const SearchBankruptcyResults = ({
  bankruptcyEvents,
  closeSearchDrawer,
}: Props) => {
  const navigate = useNavigate();

  if (bankruptcyEvents.length === 0) {
    return null;
  }

  return (
    <Table
      data={bankruptcyEvents}
      columns={[
        jobNumberColumn,
        tickerColumn,
        typeColumn,
        recordDateColumn,
        stageColumn,
      ]}
      rowOnClick={(event) => {
        navigate(`/bankruptcy-events/${event.id}/details`);
        closeSearchDrawer();
      }}
    />
  );
};
